import { DocumentStatusAllGroupingsResource } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const getDocumentStatusAllGroupings = async (
  constructGet: ConstructGet,
  documentParams: DocumentParams,
  documentId: string,
): Promise<
  NonPaginatedResponse<DocumentStatusAllGroupingsResource> | undefined
> =>
  constructGet<NonPaginatedResponse<DocumentStatusAllGroupingsResource>>(
    `${DOCUMENTS_BASE_PATH}/${documentId}/status/${documentParams.definition}/grouping`,
    {
      headers: buildHeadersFromDocumentParams(documentParams),
    },
  );
